import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/globals.css";
import "./styles/ui-system.css";
import { reloadForNewBuild } from "./components/common/ErrorBoundary";

// Vite fires this when a lazy chunk's preload fails -- almost always a tab
// left open across a deploy. Reload onto the new build instead of crashing.
window.addEventListener("vite:preloadError", (event) => {
  if (reloadForNewBuild()) event.preventDefault();
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
